
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { OrganizationWithRelations } from "@/types/organization.types";

interface ClientPreferencesCardProps {
  organization: OrganizationWithRelations;
}

export function ClientPreferencesCard({ organization }: ClientPreferencesCardProps) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Client Preferences</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {organization.personality && (
          <div>
            <span className="text-sm font-medium text-muted-foreground">Personality:</span>
            <p className="text-sm mt-1">{organization.personality}</p>
          </div>
        )}
        
        {organization.gift_preferences && (
          <div className="mt-3">
            <span className="text-sm font-medium text-muted-foreground">Gift Preferences:</span>
            <p className="text-sm mt-1">{organization.gift_preferences}</p>
          </div>
        )}
        
        {organization.gender_preference && (
          <div className="mt-3">
            <span className="text-sm font-medium text-muted-foreground">Gender Preference:</span>
            <p className="text-sm mt-1">{organization.gender_preference}</p>
          </div>
        )}
        
        {!organization.personality && !organization.gift_preferences && !organization.gender_preference && (
          <div className="text-sm text-muted-foreground italic">
            No preference information added
          </div>
        )}
      </CardContent>
    </Card>
  );
}
